import { useServices, useTenantConfig } from 'contexts';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { useDebounceValue } from './useDebounce';

const MIN_LENGTH_SUGGESTION_TEXT = 4;
export const useSuggestionAddress = ({
  province: defaultProvince,
  district: defaultDistrict,
  ward: defaultWard,
}: {
  province: string;
  district?: string;
  ward: string;
}) => {
  const [suggestInputText, setSuggestInputText] = useState('');
  const [openListSuggestion, setOpenListSuggestion] = useState(false);
  const [province, setProvince] = useState(defaultProvince);
  const [district, setDistrict] = useState(defaultDistrict);
  const [ward, setWard] = useState(defaultWard);

  const { locationServiceV2 } = useServices();
  const { epicOmni1589, epicOmni1584Phase2SuggestAddress } = useTenantConfig();

  const debounceSuggestInputText = useDebounceValue(suggestInputText, 500);

  const { data: dataSuggestion = [], isValidating } = useSWR(
    !!debounceSuggestInputText &&
      debounceSuggestInputText.length >= MIN_LENGTH_SUGGESTION_TEXT &&
      epicOmni1584Phase2SuggestAddress
      ? ['suggestInputText', debounceSuggestInputText]
      : null,
    async () => {
      const res = await locationServiceV2.getAddressSuggestions({
        inputAddress: epicOmni1589
          ? `${debounceSuggestInputText}${ward ? `, ${ward}` : ''}${
              province ? `, ${province}` : ''
            }`
          : `${debounceSuggestInputText}${ward ? `, ${ward}` : ''}${
              district ? `, ${district}` : ''
            }${province ? `, ${province}` : ''}`,
      });

      return res;
    },
    { revalidateOnFocus: false, fallbackData: [], shouldRetryOnError: false },
  );

  useEffect(() => {
    if (!!defaultProvince) {
      setProvince(defaultProvince);
    }
    if (!!defaultDistrict) {
      setDistrict(defaultDistrict);
    }
    if (!!defaultWard) {
      setWard(defaultWard);
    }
  }, [defaultProvince, defaultDistrict, defaultWard]);

  return {
    setSuggestInputText,
    dataSuggestion: !!dataSuggestion.length ? dataSuggestion : [],
    openListSuggestion,
    setOpenListSuggestion,
    setProvince,
    setDistrict,
    setWard,
    isLoadingSuggest: isValidating,
  };
};
